'use strict';

var processInclude = require('BASE/util');

$(document).ready(function() {
  processInclude(require('./storeLocator/storeLocator'));



  async function fetchPlace(query) {
    try {
        var url = $('#StoreLocator_geocode').val() + '?query=' + query;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        var places = data.data.elementi;

        const countries = places.map(country => ({
            name: country.geoname_desc,
            id: country.geoname_id     
        }));

        
        return countries;
    } catch (error) {
        console.error('Error fetching countries:', error);
        return [];
    }
    }

async function fetchCofanetto(query) {
    try {
        var url = $('#GetSuggestionsStorelocator').val() + '?query=' + query;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        var cofanetti = data.transforedProducts;
        const countries = cofanetti.map(cofanetto => ({
            name: cofanetto.name,
            id: cofanetto.id
        }));

        
        return countries;
        } catch (error) {
            console.error('Error fetching countries:', error);
            return [];
        }
    }

  let debounceTimeout = null;
    let isLocationLoading = false;
  accessibleAutocomplete.enhanceSelectElement({
    selectElement: document.querySelector('#location-picker'),
    placeholder: 'Digita il nome di una località...',
    defaultValue: '',
    minLength: 3,
    autoselect: false,
    displayMenu: 'overlay',
    confirmOnBlur: false,
        tStatusNoResults: () => isLocationLoading ? '' : 'Nessun risultato trovato',
        tNoResults: () => isLocationLoading ? '' : 'Nessun risultato trovato',
    source: async (query, populateResults) => {
                clearTimeout(debounceTimeout);
                isLocationLoading = true;
                debounceTimeout = setTimeout(async () => {
                    const results = await fetchPlace(query);
                    isLocationLoading = false;
                    populateResults(results.map(item => item.name));
                }, 300);
    },
    onConfirm: async (selectedName) => {
      if (!selectedName) return;

      const nameInput = document.getElementById('selected-name');
      const valueInput = document.getElementById('selected-value');
      var selected = selectedName.split(/[\(\[]/)[0];
      
      const results = await fetchPlace(selected); 
      const selectedCountry = results.find(country => country.name === selectedName);

      if (selectedCountry) {
          nameInput.value = selectedCountry.name;
          valueInput.value = selectedCountry.id;
          document.getElementById("location-picker__listbox").innerHTML = "";
      }
  }
  })

    let isCofanettoLoading = false;
  accessibleAutocomplete.enhanceSelectElement({
    selectElement: document.querySelector('#confanetto-picker'),
    placeholder: 'Ricerca (parole chiave, ecc.)',
    defaultValue: '',
    minLength: 3,
    autoselect: false,
    displayMenu: 'overlay',
    confirmOnBlur: false,
        tStatusNoResults: () => isCofanettoLoading ? '' : 'Nessun risultato trovato',
        tNoResults: () => isCofanettoLoading ? '' : 'Nessun risultato trovato',
    source: async (query, populateResults) => {
            isCofanettoLoading = true;
            const results = await fetchCofanetto(query);
            isCofanettoLoading = false;
      populateResults(results.map(item => item.name));
    },
     
    onConfirm: async (selectedName) => {
      if (!selectedName) return;

      const nameInput = document.getElementById('cofanetto-selected-name');
      const valueInput = document.getElementById('cofanetto-selected-value');
      const results = await fetchCofanetto(selectedName); 
      const selectedCountry = results.find(country => country.name === selectedName);

      if (selectedCountry) {
          nameInput.value = selectedCountry.name;
          valueInput.value = selectedCountry.value;
          valueInput.value = selectedCountry.id;
      }
  }
  })
});
